/* Honey Healed Apothecary — theme.js (vanilla, no dependencies) */
(function () {
  'use strict';
  var T = window.theme || { routes: {}, strings: {} };
  var root = (T.routes.root || '/').replace(/\/?$/, '/');

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '${{amount}}';
    function fmt(n, precision, thousands, decimal) {
      precision = precision === undefined ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var btn = document.querySelector('[data-drawer-open="' + id + '"][aria-expanded]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    var focusable = d.querySelector('.drawer__panel button, .drawer__panel a');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }
  function closeDrawers() {
    document.querySelectorAll('[data-drawer].is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[data-drawer-open][aria-expanded]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    document.body.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var id = opener.getAttribute('data-drawer-open');
      if (id === 'CartDrawer' && document.body.classList.contains('template-cart')) return;
      e.preventDefault();
      openDrawer(id);
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Auto-submit selects (localization, sort) ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-autosubmit]')) e.target.form.submit();
  });

  /* ---------- Announcement rotation ---------- */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var items = bar.querySelectorAll('.announcement__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, parseInt(bar.dataset.interval, 10) || 5000);
  });

  /* ---------- Toast ---------- */
  function toast(msg) {
    var t = document.querySelector('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-visible');
    setTimeout(function () { t.classList.remove('is-visible'); }, 3200);
  }

  /* ---------- Cart ---------- */
  function renderCartSections(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = doc.querySelector('[data-cart-inner]');
    if (!fresh) return;
    var count = fresh.getAttribute('data-count');
    var body = document.querySelector('[data-cart-body]');
    if (body) body.innerHTML = fresh.outerHTML;
    var page = document.querySelector('[data-cart-page]');
    if (page) page.innerHTML = fresh.outerHTML;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === '0');
    });
    document.querySelectorAll('[data-cart-count-label]').forEach(function (el) { el.textContent = '(' + count + ')'; });
  }

  function addToCart(form) {
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) { toast(res.json.description || res.json.message || T.strings.error); return; }
        renderCartSections(res.json.sections);
        if (document.body.classList.contains('template-cart')) return;
        openDrawer('CartDrawer');
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-product-form]')) return;
    e.preventDefault();
    addToCart(form);
  });

  function changeLine(line, qty) {
    var body = document.querySelector('[data-cart-body]') || document.querySelector('[data-cart-page]');
    if (body) body.style.opacity = '.55';
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: Math.max(0, parseInt(qty, 10)), sections: ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.status) { toast(j.description || j.message || T.strings.error); return; }
        renderCartSections(j.sections);
      })
      .catch(function () { toast(T.strings.error); })
      .finally(function () {
        document.querySelectorAll('[data-cart-body],[data-cart-page]').forEach(function (b) { b.style.opacity = ''; });
      });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    changeLine(b.getAttribute('data-line-change'), b.getAttribute('data-qty'));
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var input = (minus || plus).closest('[data-qty]').querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    input.value = minus ? Math.max(1, v - 1) : v + 1;
  });

  /* ---------- Variant picker ---------- */
  document.querySelectorAll('[data-buy]').forEach(function (buy) {
    var jsonEl = buy.querySelector('[data-variants]');
    if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);
    var radios = buy.querySelectorAll('input[data-opt-index]');
    if (!radios.length) return;
    var scope = buy.closest('section') || document;

    function selected() {
      var opts = [];
      radios.forEach(function (r) { if (r.checked) opts[parseInt(r.dataset.optIndex, 10)] = r.value; });
      return opts;
    }
    function update() {
      var opts = selected();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      opts.forEach(function (val, i) { var l = buy.querySelector('[data-opt-value="' + i + '"]'); if (l) l.textContent = val; });
      var atc = buy.querySelector('[data-atc]');
      var label = buy.querySelector('[data-atc-label]');
      var priceEl = buy.querySelector('[data-atc-price]');
      var sticky = scope.querySelector('[data-sticky-trigger]');
      if (!v) {
        atc.disabled = true; label.textContent = T.strings.unavailable; priceEl.textContent = '';
        if (sticky) sticky.disabled = true;
        return;
      }
      buy.querySelector('[data-variant-id]').value = v.id;
      atc.disabled = !v.available;
      label.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
      priceEl.textContent = v.available ? '· ' + formatMoney(v.price) : '';
      if (sticky) sticky.disabled = !v.available;
      var sp = scope.querySelector('[data-sticky-price]');
      if (sp) sp.textContent = formatMoney(v.price);

      scope.querySelectorAll('[data-price]').forEach(function (p) {
        var cur = p.querySelector('.price__current');
        var from = p.querySelector('.price__from');
        if (from) from.remove();
        if (cur) cur.textContent = formatMoney(v.price);
        var cmp = p.querySelector('.price__compare');
        var badge = p.querySelector('.badge--sale');
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        p.classList.toggle('price--sale', !!onSale);
        if (onSale) {
          if (!cmp) { cmp = document.createElement('s'); cmp.className = 'price__compare'; p.appendChild(cmp); }
          cmp.textContent = formatMoney(v.compare_at_price);
          if (!badge) { badge = document.createElement('span'); badge.className = 'badge badge--sale'; p.appendChild(badge); }
          badge.textContent = (p.dataset.saveTpl || '__AMT__').replace('__AMT__', formatMoney(v.compare_at_price - v.price));
        } else {
          if (cmp) cmp.remove();
          if (badge) badge.remove();
        }
      });

      if (buy.dataset.section && scope.matches('[data-pdp]')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(null, '', url.toString());
      }
      if (v.featured_media) {
        var slide = scope.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (slide) slide.parentElement.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
    }
    radios.forEach(function (r) { r.addEventListener('change', update); });
  });

  /* ---------- Gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-gallery-track]');
    var thumbs = g.querySelectorAll('[data-thumb]');
    var dots = g.querySelectorAll('.gallery__dots span');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var slide = track.querySelector('[data-media-id="' + t.dataset.thumb + '"]');
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        ticking = false;
      });
    }, { passive: true });
  });

  /* ---------- Sticky add to cart ---------- */
  document.querySelectorAll('[data-sticky-atc]').forEach(function (bar) {
    var section = bar.closest('[data-pdp]');
    var main = section && section.querySelector('[data-main-atc]');
    if (!main || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }).observe(main);
    var trigger = bar.querySelector('[data-sticky-trigger]');
    trigger.addEventListener('click', function () {
      var form = main.querySelector('[data-product-form]');
      if (form) addToCart(form);
    });
  });

  /* ---------- Product recommendations ---------- */
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    if (el.children.length && el.querySelector('.card')) return;
    var load = function () {
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' });
      io.observe(el);
    } else { load(); }
  });
})();

/* Slideshow */
(function () {
  document.querySelectorAll('[data-slideshow]').forEach(function (s) {
    var track = s.querySelector('[data-slides]');
    var dots = s.querySelectorAll('[data-dot]');
    var n = track.children.length;
    if (n < 2) return;
    function index() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) { i = (i + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    s.querySelector('[data-prev]').addEventListener('click', function () { go(index() - 1); });
    s.querySelector('[data-next]').addEventListener('click', function () { go(index() + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.dot, 10)); }); });
    track.addEventListener('scroll', function () {
      var i = index();
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }, { passive: true });
    if (s.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var timer = setInterval(function () { go(index() + 1); }, parseInt(s.dataset.speed, 10) || 6000);
      s.addEventListener('pointerenter', function () { clearInterval(timer); });
      s.addEventListener('touchstart', function () { clearInterval(timer); }, { passive: true });
    }
  });
})();
